import { BasePill } from "./BasePill";
import { PillProps } from "./types";

export const ErrorPill = ({
  children,
  variant = "DEFAULT",
  ...props
}: PillProps) => {
  return (
    <BasePill {...props} type="ERROR" variant={variant}>
      {children}
    </BasePill>
  );
};
